<template>
    <painel titulo="Chamados Não Atendidos" icone="pi pi-phone" :refreshFunction="obterTodosNaoAtendidos">
        <div class="container text-center mt-5 mb-5">
            <div class="table-responsive my-5">
                <tabela
                    headerStyle="width: 3em"
                    :stateKey="idTabela"
                    :salvarEstado="false"
                    :data="chamadosNaoAtendidos"
                    :mostrarExportar="true"
                    :exportFilename="fileName(true)"
                >
                    <template #conteudo>
                        <Column headerStyle="width: 70px">
                            <template #body="slotProps">
                                <btn-visualizar
                                    title="Visualizar Chamado"
                                    class="flex align-items-center justify-content-center"
                                    @click="visualizarChamado(slotProps.data)"
                                ></btn-visualizar>
                            </template>
                        </Column>
                        <Column header="Número" field="id" :sortable="true"></Column>
                        <Column header="E-mail Usuário" field="createdBy" :sortable="true"></Column>
                        <Column header="Tipo Chamado" field="tipoChamado" :sortable="true">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.tipoChamado == 'CONSULTORIA_EXPREESS'
                                        ? 'Consultoria Express'
                                        : slotProps.data.tipoChamado == 'PRODUTO_REAL'
                                        ? 'Produto Real'
                                        : 'Curadoria'
                                }}
                            </template>
                        </Column>
                        <Column header="Data Criação" field="created" :sortable="true">
                            <template #body="slotProps">
                                {{ $dateFormat(slotProps.data.created, 'DD/MM/YYYY HH:mm:ss') }}
                            </template>
                        </Column>
                        <Column header="Data Atendimento" field="dataAtendimento" :sortable="true">
                            <template #body="slotProps">
                                {{ $dateFormat(slotProps.data.dataAtendimento, 'DD/MM/YYYY HH:mm:ss') }}
                            </template>
                        </Column>

                        <Column header="Status">
                            <template #body="slotProps">
                                <TagStatusChamado :status="slotProps.data.statusChamado" />
                            </template>
                        </Column>
                    </template>
                </tabela>
            </div>
        </div>
    </painel>
    <painel titulo="Chamados Atendidos" icone="pi pi-user" :refreshFunction="obterTodosAtendidos">
        <div class="container text-center mt-5 mb-5">
            <div class="table-responsive my-5">
                <tabela
                    headerStyle="width: 3em"
                    :stateKey="idTabela"
                    :salvarEstado="false"
                    :data="chamadosAtendidos"
                    :mostrarExportar="true"
                    :exportFilename="fileName(false)"
                >
                    <template #conteudo>
                        <Column headerStyle="width: 70px">
                            <template #body="slotProps">
                                <btn-visualizar
                                    title="Visualizar Chamado"
                                    class="flex align-items-center justify-content-center"
                                    @click="visualizarChamado(slotProps.data)"
                                ></btn-visualizar>
                            </template>
                        </Column>
                        <Column header="Número" field="id" :sortable="true"></Column>
                        <Column header="E-mail Usuário" field="createdBy" :sortable="true"></Column>
                        <Column header="Tipo Chamado" field="tipoChamado" :sortable="true">
                            <template #body="slotProps">
                                {{
                                    slotProps.data.tipoChamado == 'CONSULTORIA_EXPREESS'
                                        ? 'Consultoria Express'
                                        : slotProps.data.tipoChamado == 'PRODUTO_REAL'
                                        ? 'Produto Real'
                                        : 'Curadoria'
                                }}
                            </template>
                        </Column>
                        <Column header="Data Criação" field="created" :sortable="true">
                            <template #body="slotProps">
                                {{ $dateFormat(slotProps.data.created, 'DD/MM/YYYY HH:mm:ss') }}
                            </template>
                        </Column>
                        <Column header="Data Atendimento" field="dataAtendimento" :sortable="true">
                            <template #body="slotProps">
                                {{ $dateFormat(slotProps.data.dataAtendimento, 'DD/MM/YYYY HH:mm:ss') }}
                            </template>
                        </Column>

                        <Column header="Status">
                            <template #body="slotProps">
                                <TagStatusChamado :status="slotProps.data.statusChamado" />
                            </template>
                        </Column>
                    </template>
                </tabela>
            </div>
        </div>
    </painel>
    <DialogChamado :visible="modal" :chamado="chamado" @close="fecharModal"></DialogChamado>
    <router-view></router-view>
</template>

<script>
import BtnVisualizar from '../components/BtnVisualizar.vue';
import DialogChamado from './DialogChamado.vue';
import Services from './service';
import TagStatusChamado from './TagStatusChamado.vue';

export default {
    components: { BtnVisualizar, DialogChamado, TagStatusChamado },
    name: 'Chamados',
    data() {
        return {
            idTabela: 'Chamados',
            inativos: true,
            data: [],
            modal: false,
            chamado: {},
            chamadosNaoAtendidos: [],
            chamadosAtendidos: [],
            tag: '',
        };
    },
    mounted() {
        this.obterTodos();
    },
    computed: {
        mostrarListagem() {
            return this.$route.name === 'Atendimento Chamado';
        },
    },
    beforeRouteUpdate() {
        this.obterTodos();
    },
    methods: {
        fileName(obj) {
            const currentDate = new Date();
            const day = String(currentDate.getDate()).padStart(2, '0');
            const month = String(currentDate.getMonth() + 1).padStart(2, '0');
            const year = currentDate.getFullYear();

            const prefix = obj ? 'Chamados_Nao_Atendidos' : 'Chamados_Atendidos';

            return `${prefix}_${day}-${month}-${year}`;
        },
        visualizarChamado(data) {
            this.chamado = data;
            this.$store.dispatch('addRequest');
            Services.obterOrigemPorChamado(data).then((response) => {
                if (response?.success) {
                    this.chamado.origem = response.data;
                    this.chamado.dataCriacao = this.$dateFormat(this.chamado.created, 'DD/MM/YYYY HH:mm:ss');

                    if (this.chamado.origem.solicitacaoProdutoReal) {
                        this.chamado.origem.solicitacaoProdutoReal.dataInicio = this.$dateFormat(
                            this.chamado.origem.solicitacaoProdutoReal.dataInicio,
                            'DD/MM/YYYY'
                        );
                        this.chamado.origem.solicitacaoProdutoReal.dataFim = this.$dateFormat(this.chamado.origem.solicitacaoProdutoReal.dataFim, 'DD/MM/YYYY');
                        this.chamado.origem.solicitacaoProdutoReal.preco = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(
                            this.chamado.origem.solicitacaoProdutoReal.preco
                        );
                        this.chamado.origem.solicitacaoProdutoReal.geraCertificado = this.chamado.origem.solicitacaoProdutoReal.geraCertificado ? 'Sim' : 'Não';
                    }

                    if (this.chamado.origem.consultoriaExpress) {
                        this.chamado.origem.consultoriaExpress.dataNascimento = this.$dateFormat(
                            this.chamado.origem.consultoriaExpress.dataNascimento,
                            'DD/MM/YYYY'
                        );
                    }

                    if (this.chamado.origem.curadoria) {
                        this.chamado.origem.curadoria.prazo = this.$dateFormat(this.chamado.origem.curadoria.prazo, 'DD/MM/YYYY');
                    }

                    this.modal = true;
                }

                this.$store.dispatch('removeRequest');
            });
        },
        obterTodos() {
            this.obterTodosNaoAtendidos();
            this.obterTodosAtendidos();
        },
        obterTodosNaoAtendidos() {
            this.$store.dispatch('addRequest');
            Services.obterTodos(['EM_ANALISE', 'EM_CONSOLIDACAO']).then((response) => {
                if (response?.success) {
                    this.chamadosNaoAtendidos = response.data;
                }

                this.$store.dispatch('removeRequest');
            });
        },
        obterTodosAtendidos() {
            this.$store.dispatch('addRequest');
            Services.obterTodos(['DEVOLVIDO_PARA_AJUSTES', 'PRODUTO_CADASTRADO', 'PRODUTO_NAO_CADASTRADO', 'ENVIADO']).then((response) => {
                if (response?.success) {
                    this.chamadosAtendidos = response.data;
                }

                this.$store.dispatch('removeRequest');
            });
        },
        fecharModal(atualizar) {
            this.modal = false;
            if (atualizar) {
                this.obterTodos();
            }
        },
        mostrarInativos(inativo) {
            this.inativos = inativo;
        },
    },
    watch: {
        inativos() {
            this.obterTodos();
        },
    },
};
</script>
